import { render, staticRenderFns } from "./LoginChoice.vue?vue&type=template&id=4b4c8ff6&scoped=true"
import script from "./LoginChoice.vue?vue&type=script&lang=js"
export * from "./LoginChoice.vue?vue&type=script&lang=js"
import style0 from "./LoginChoice.vue?vue&type=style&index=0&id=4b4c8ff6&prod&lang=scss&scoped=true"
import style1 from "./LoginChoice.vue?vue&type=style&index=1&id=4b4c8ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c8ff6",
  null
  
)

export default component.exports